// критический css
import "./service.scss"; 

import { onDomReady } from "./services/on-dom-ready";
window.onDomReady = onDomReady;

// helpers
import { isInViewport } from "./services/helpers/is-in-viewport";
window.isInViewport = isInViewport;
import { triggerEvent } from "./services/helpers/trigger-event";
window.triggerEvent = triggerEvent;
import "./services/helpers/form-data";
import "./services/helpers/form";

// modals
import { initModals } from "./components/modal/init";
initModals();

// checkAuth
import { checkAuth, showAuthPopup } from "./services/check-auth";
window.checkAuth = checkAuth;
window.showAuthPopup = showAuthPopup;

import { initAuthBlocks } from "./services/store-form";
onDomReady.then(() => {
	initAuthBlocks();
});

document.addEventListener("click", (e) => {
  let needAuth = e.target.closest("[data-auth]");
  if (needAuth) {
    e.stopImmediatePropagation();

    // Для авторизации через телеграм
    // нужно сначала получить ключ авторизации
	fetch("/auth/telegram", {
		method: "POST"
	})
	.then(res => res.json())
	.then(json => {
		localStorage["authKey"] = json.authKey;
		window._telegramUrl = json.telegramUrl;
		window.checkAuth();
	})
	.catch(err => {
		console.error(err);
		window.checkAuth();
	})
  }
})

// вызов окна подтверждения
import { confirm } from "./services/confirm";
window.confirm = confirm;

// запрос почты
import { getEmail } from "./services/get-email";
window.getEmail = getEmail;

// показ ошибки в попапе
import { showVkError } from "./services/show-vk-error";
window.showVkError = showVkError;

// добавление обработчиков к событиями scroll, resize, document.click
import addHandler from "./services/events-handlers";
window.addHandler = addHandler;

// запрос к api
import { apiFetch } from "./services/api-fetch";
window.apiFetch = apiFetch;

// форматирование слов
import getWordEnding from "./services/helpers/get-word-ending";
window.getWordEnding = getWordEnding;

// увеличение изображений
import { showFullImage } from "./services/show-full-image";
window.showFullImage = showFullImage;

// пожаловаться
import { complain } from "./services/complain";
window.complain = complain;

// закрепить/открепить
import { pin } from "./services/pin";
window.pin = pin;

import { bugReport } from "./services/bug-report";
window.bugReport = bugReport;

import { createAdaptive } from "./services/create-adaptive";
window.createAdaptive = createAdaptive;



